import React, {Component} from 'react'
import {
  Input,
  Radio,
  Form,
  Col,
  Button,
  message,
  Table,
  Select,
  Tabs,
  Row,
  Icon,
} from 'antd'
import Layouts from './components/Layouts'
import apiRequest from './hooks/ApiRequest'
import {toast} from 'react-toastify'
class GeneralSettings extends Component {
  constructor() {
    super()
    this.state = {
      stampDuty: 0,
      smtpPort: '',
      smtpPassword: '',
      currency: '',
      reinsuranceLimit: 0,
      reinsuranceLimitMail: '',
      smtpDisplayName: '',
      smtpHost: '',
      smtpMail: '',
      allData: '',
      riskItemList: [],
      riskCoverDrop: [],
      newRiskCover: '',
      productId: '',
      data: '',
      passwordVisible: false,
      columns: [
        {key: '1', title: 'Risk Name', dataIndex: 'riskname'},
        {key: '2', title: 'Product Id', dataIndex: 'productid'},
        {key: '3', title: 'Risk Cover Id', dataIndex: 'riskcoverid'},
      ],
    }
  }

  componentDidMount() {
    this.fetchMasterSettings()
  }
  togglePasswordVisibility = () => {
    this.setState(prev => ({
      passwordVisible: !prev.passwordVisible,
    }));
  };
  fetchMasterSettings = async () => {
    const url = `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/MasterSetting`

    try {
      const response = await apiRequest(url, 'GET')

      if (
        response.success &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        const data = response.data
        this.setState({allData: data})

        const first = data[0]

        this.setState({
          stampDuty: first.stampduty,
          smtpPort: first.smtpport,
          smtpPassword: first.smtppassword,
          currency: first.currency,
          reinsuranceLimit: first.reinsurancelimit,
          reinsuranceLimitMail: first.reinsurancelimitmail,
          smtpDisplayName: first.smtpdisplayname,
          smtpHost: first.smtphost,
          smtpMail: first.smtpmail,
          businessaddress: first.businessaddress,
        })
      } else {
        console.warn('No Master Settings data received.')
      }
    } catch (err) {
      console.error('Error fetching Master Settings:', err)
    }
  }

  // by Khushal - 19/05/25
  // handleSubmit = async e => {
  //   e.preventDefault()
  //   this.props.form.validateFields((err, values) => {
  //     console.log('this.state.allData',this.state.allData);

  //     if (!err) {
  //       var res = []
  //       if (this.state.allData.length !== 0) {
  //         res = {
  //           stampduty: values.stampDuty,
  //           smtpport: values.smtpPort,
  //           smtppassword: values.smtpPassword,
  //           currency: values.currency,
  //           reinsurancelimit: values.reinsuranceLimit,
  //           reinsurancelimitmail: values.reinsuranceLimitMail,
  //           smtpdisplayname: values.smtpDisplayName,
  //           smtphost: values.smtpHost,
  //           smtpmail: values.smtpMail,
  //           businessaddress: values.businessaddress,
  //           createdby: this.state.allData[0].createdby,
  //           createddate: this.state.allData[0].createddate,
  //           id: this.state.allData[0].id,
  //           isactive: this.state.allData[0].isactive,
  //           modifiedby: this.state.allData[0].modifiedby,
  //           modifiedbydate: this.state.allData[0].modifiedbydate,
  //           policynumber: this.state.allData[0].policynumber,
  //           quotationnumber: this.state.allData[0].quotationnumber,
  //           productid: parseInt(localStorage.getItem('productId')),
  //         }
  //       } else {
  //         res = {
  //           stampduty: values.stampDuty,
  //           smtpport: values.smtpPort,
  //           smtppassword: values.smtpPassword,
  //           currency: values.currency,
  //           reinsurancelimit: values.reinsuranceLimit,
  //           reinsurancelimitmail: values.reinsuranceLimitMail,
  //           smtpdisplayname: values.smtpDisplayName,
  //           smtphost: values.smtpHost,
  //           smtpmail: values.smtpMail,
  //           businessaddress: values.businessaddress,
  //           createdby: localStorage.getItem('loggedInUserID'),
  //           createddate: this.state.allData[0].createddate,
  //           id: 0,
  //           isactive: true,
  //           modifiedby: parseInt(localStorage.getItem('loggedInUserID')),
  //           modifiedbydate: this.state.allData[0].modifiedbydate,
  //           policynumber: '',
  //           quotationnumber: '',
  //           productid: parseInt(localStorage.getItem('productId')),
  //         }
  //       }

  //       console.log(res)
  //       const requestMetadata = {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(res),
  //       }
  //       const response = await apiRequest(
  //         process.env.REACT_APP_BASE_URL_ADMIN + '/Product/MasterSetting', "POST",
  //         res,
  //       ).then(res => {
  //         if (res.status === 200) {
  //           message.success('Settings Updated Successfully !!')
  //           //window.location.reload(false)
  //         }
  //       })
  //     }
  //   })
  // }

  handleSubmit = async e => {
    e.preventDefault()

    try {
      const values = await this.props.form.validateFields()

      let res = {}
      const {allData} = this.state

      if (allData.length !== 0) {
        res = {
          stampduty: values.stampDuty,
          smtpport: values.smtpPort,
          smtppassword: values.smtpPassword,
          currency: values.currency,
          reinsurancelimit:0,
          reinsurancelimitmail: '',
          smtpdisplayname: values.smtpDisplayName,
          smtphost: values.smtpHost,
          smtpmail: values.smtpMail,
          businessaddress: values.businessaddress,
          createdby: allData[0].createdby,
          createddate: allData[0].createddate,
          id: allData[0].id,
          isactive: allData[0].isactive,
          modifiedby: allData[0].modifiedby,
          modifiedbydate: allData[0].modifiedbydate,
          policynumber: allData[0].policynumber,
          quotationnumber: allData[0].quotationnumber,
          productid: parseInt(localStorage.getItem('productId')),
        }
      } else {
        const userId = parseInt(localStorage.getItem('loggedInUserID'))
        res = {
          stampduty: values.stampDuty,
          smtpport: values.smtpPort,
          smtppassword: values.smtpPassword,
          currency: values.currency,
          reinsurancelimit: 0,
          reinsurancelimitmail: '',
          smtpdisplayname: values.smtpDisplayName,
          smtphost: values.smtpHost,
          smtpmail: values.smtpMail,
          businessaddress: values.businessaddress,
          createdby: userId,
          createddate: this.state.allData[0].createddate,
          id: 0,
          isactive: true,
          modifiedby: userId,
          modifiedbydate: this.state.allData[0].modifiedbydate,
          policynumber: '',
          quotationnumber: '',
          productid: parseInt(localStorage.getItem('productId')),
        }
      }

      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/MasterSetting`,
        'POST',
        res,
      )

      if (response.status) {
        toast.success('Settings Updated Successfully !!')
      }
    } catch (err) {
      console.error('Validation failed:', err)
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form
     const { smtpPassword, passwordVisible } = this.state;

    return (
      <div title="assets" className="ant-layout-content dashboard">
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={24} md={24} lg={12}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  {' '}
                  Manage General Settings
                </h3>
              </div>
            </Col>
          </Row>
        </div>
        <div className="dash-bg-white">
          <Form onSubmit={this.handleSubmit} id="my-form">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Stamp Duty">
                  {getFieldDecorator('stampDuty', {
                    rules: [
                      {
                        required: true,
                        message: 'Please input Stamp Duty!',
                      },
                    ],
                    initialValue: this.state.stampDuty,
                  })(
                    <Input
                      placeholder="Stamp Duty"
                      setfieldsvalue={this.state.stampDuty}
                    />,
                  )}
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="SMTP Port">
                  {getFieldDecorator('smtpPort', {
                    rules: [
                      {
                        required: true,
                        message: 'Please input SMTP Port!',
                        whitespace: false,
                      },
                    ],
                    initialValue: this.state.smtpPort,
                  })(
                    <Input
                      placeholder="SMTP Port"
                      setfieldsvalue={this.state.smtpPort}
                    />,
                  )}
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="SMTP Password">
                  {getFieldDecorator('smtpPassword', {
                    rules: [
                      {
                        required: true,
                        message: 'Please enter SMTP Password!',
                        whitespace: false,
                      },
                    ],
                    initialValue: smtpPassword,
                  })(
                    <Input
                      placeholder="SMTP Password"
                      type={passwordVisible ? 'text' : 'password'}
                      suffix={
                        <Icon
                          type={passwordVisible ? 'eye-invisible' : 'eye'}
                          onClick={this.togglePasswordVisibility}
                          style={{cursor: 'pointer'}}
                        />
                      }
                    />,
                  )}
                </Form.Item>
              </Col>

              {/* <Col xs={24} md={12} lg={4}>
                <Form.Item label="Currency">
                  {getFieldDecorator('currency', {
                    rules: [
                      {
                        required: true,
                        message: 'Please input Currency!',
                        whitespace: false,
                      },
                    ],
                    initialValue: this.state.currency,
                  })(
                    <Input
                      placeholder="Currency"
                      value={this.state.currency}
                    />,
                  )}
                </Form.Item>
              </Col> */}

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="SMTP Display Name">
                  {getFieldDecorator('smtpDisplayName', {
                    rules: [
                      {
                        required: true,
                        message: 'Please input SMTP Display Name!',
                        whitespace: false,
                      },
                    ],
                    initialValue: this.state.smtpDisplayName,
                  })(
                    <Input
                      placeholder="SMTP Display Name"
                      setfieldsvalue={this.state.smtpDisplayName}
                    />,
                  )}
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="SMTP Host">
                  {getFieldDecorator('smtpHost', {
                    rules: [
                      {
                        required: true,
                        message: 'Please input SMTP Host!',
                        whitespace: false,
                      },
                    ],
                    initialValue: this.state.smtpHost,
                  })(
                    <Input
                      placeholder="SMTP Host"
                      setfieldsvalue={this.state.smtpHost}
                    />,
                  )}
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="SMTP Mail">
                  {getFieldDecorator('smtpMail', {
                    rules: [
                      {
                        required: true,
                        message: 'Please input SMTP Mail!',
                        whitespace: false,
                      },
                    ],
                    initialValue: this.state.smtpMail,
                  })(
                    <Input
                      placeholder="SMTP Mail"
                      setfieldsvalue={this.state.smtpMail}
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Business Address">
                  {getFieldDecorator('businessaddress', {
                    rules: [
                      {
                        required: true,
                        message: 'Please input business address !',
                        whitespace: false,
                      },
                    ],
                    initialValue: this.state.businessaddress,
                  })(
                    <Input
                      placeholder="business address"
                      setfieldsvalue={this.state.businessaddress}
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={4}>
                <Button
                  htmlType="submit"
                  size="default"
                  className="primary m-t-22">
                  Update
                </Button>
              </Col>
            </Row>{' '}
          </Form>
        </div>
      </div>
    )
  }
}

const WrappedGeneralSettings = Form.create({name: 'Homeinsurance_list'})(
  GeneralSettings,
)

export default WrappedGeneralSettings